export const formatShowingOf = (template: string, visible: number, total: number): string =>
  template.replace('[x]', String(visible)).replace('[y]', String(total));
